import { render } from "./FilterDialog.vue?vue&type=template&id=4581b976&bindings={\"size\":\"props\",\"align\":\"props\",\"name\":\"props\",\"dismiss\":\"options\"}"
import script from "./FilterDialog.vue?vue&type=script&lang=js"
export * from "./FilterDialog.vue?vue&type=script&lang=js"

import "./FilterDialog.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script